import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DiagramComponent, Diagram, NodeModel, ConnectorModel, SnapSettingsModel,
   LayoutModel,   ZoomOptions,DataSourceModel, TextModel, DecoratorModel, ShapeStyleModel, 
   DataBindingService, HierarchicalTreeService, 
   DiagramTools,
   TreeInfo,
   NodeConstraints,
   SelectorModel,
   SelectorConstraints,
   DiagramConstraints,
   AnnotationConstraints} from '@syncfusion/ej2-angular-diagrams';
import { created } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { DataManager, Query } from '@syncfusion/ej2-data';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { MessageService } from 'primeng/api';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-organizationdiagram',
  templateUrl: './organizationdiagram.component.html',
  styleUrls: ['./organizationdiagram.component.css'],
  providers: [HierarchicalTreeService, DataBindingService,MessageService],
  encapsulation: ViewEncapsulation.None
})
export class OrganizationdiagramComponent implements OnInit {

  constructor(
    private apiService: ApiService,
    private messageService: MessageService,
    private globalService: GlobalService
  ) { }

  @ViewChild("diagram") public diagram?: DiagramComponent;
  public orgList:any[]=[];
  public treeHier:any[]=[];
  public searchNode:string='';
  public matchingNodes:any[]=[];
  public currentIndex: number;
  public qualificheList:any[]=[];
  public snapSettings?: SnapSettingsModel;
  public items?: DataManager;
  public layout?: LayoutModel;
  public tool: DiagramTools = DiagramTools.ZoomPan;
  public dataSourceSettings?: DataSourceModel;
  public modifica:boolean=false;
  public setbordercolor='border 3px solid red;';
  public selectedItems:SelectorModel;
  //Sets the default properties for all the Nodes
  public getNodeDefaults(obj: NodeModel, diagram: Diagram): NodeModel {

      if((obj.data as any).type!='USER'){
        obj.shape = {
          type: 'HTML',
          content: '<div style="color:white;text-align:center;margin-top:5px;"<span><b>'+(obj.data as any).name+'</b></span><div style="clear:both;">'+(obj.data as any).name+'</div>',
        };
        obj.style = {
            fill: 'None',
            strokeColor: 'none',
            strokeWidth: 2,
            bold: true,
            color: 'white'
        };
        obj.borderColor = 'white';
        obj.backgroundColor = '#6BA5D7';
      }else {
        let content='<div style="text-align:center;margin-top:5px;"><span><b>'+(obj.data as any).name+'</b></span>';
        if((obj.data as any).qualifica){
          content+='<div style="clear:both;">'+(obj.data as any).qualifica+'</div></div>';
        } else {
          content+='</div>';
        }
        obj.shape = {
          type: 'HTML',
          content: content
        };
      }
      if((obj.data as any).manager){

        obj.style = {
            fill: 'None',
            strokeColor: 'none',
            strokeWidth: 2,
            bold: true,
            color: 'black'
        };
        obj.borderColor = 'white';
      
        obj.backgroundColor = 'yellow';
      }
      if((obj.data as any).type=='REP'){
        obj.backgroundColor = '#71AF17';
      }
      obj.borderWidth = 4;
      obj.width = 160;
      obj.height =45;
      (obj.shape as TextModel).margin = {
          left: 5,
          right: 5,
          top: 5,
          bottom: 5
      };
      (obj.expandIcon = {
        height: 15,
        width: 20,
        shape: 'Minus',
        fill: 'lightgray',
        offset: { x: 0.5, y: 1 },
      });
      obj.expandIcon.verticalAlignment = 'Center';
      obj.expandIcon.margin = { left: 0, right: 0, top: 0, bottom: 0 };
      obj.collapseIcon.offset = { x: 0.5, y: 1 };
      obj.collapseIcon.verticalAlignment = 'Center';
      obj.collapseIcon.margin = { left: 0, right: 0, top: 0, bottom: 0 };
      obj.collapseIcon.height = 15;
      obj.collapseIcon.width = 20;
      obj.collapseIcon.shape = 'Plus';
      obj.collapseIcon.fill = 'lightgray';
      obj.constraints= NodeConstraints.Default &~NodeConstraints.Resize;
      return obj;
  }
  //Sets the default properties for all the connectors
  public getConnectorDefaults(connector: ConnectorModel, diagram: Diagram): ConnectorModel {
      connector.style = {
          strokeColor: '#6BA5D7',
          strokeWidth: 2
      };
      (((connector as ConnectorModel).targetDecorator as DecoratorModel).style as ShapeStyleModel).fill  =  '#6BA5D7';
      (((connector as ConnectorModel).targetDecorator as DecoratorModel).style as ShapeStyleModel).strokeColor  =  '#6BA5D7';
      connector.type = 'Orthogonal';
      return connector;
  }
  ngOnInit(): void {
      this.snapSettings = {
          constraints: 0
      };
      this.selectedItems = { constraints: SelectorConstraints.All & ~SelectorConstraints.Rotate & ~SelectorConstraints.UserHandle };
      //Uses layout to auto-arrange nodes on the Diagram page
      this.layout = {
          //set the type as Organizational Chart
          type: 'OrganizationalChart',
          getLayoutInfo: (node: Node, options: TreeInfo) => {
            options.type = 'Right';
        
          },
      }
      //    orientation:'LeftToRight'

      //Configures data source for Diagram
     this.created();
  }

  buildTreeHier(node){
    if(node.name.toUpperCase()=='MODELLO ORGANIZZATIVO STRUTTURA'){
      return;
    }
    node.childs.sort((a, b) => a.manager ? -1 :  b.manager ? 1 : 0);
    node.childs.forEach((q)=>{
      if(node.name.toUpperCase()!='MODELLO ORGANIZZATIVO STRUTTURA'){
        let qua='';
        if(q.qualifica){
          let f=this.qualificheList.filter((x)=>q.qualifica==x.id);
          qua=f[0].qualifica;
        }
       
        let cn:any={
          id:q.id,
          name:q.name,
          type:q.type,
          manager:q.manager,
          qualifica:qua,
          parent:node.id
        }
        this.treeHier.push(cn);
        this.buildTreeHier(q);
      }
    });
    
  }
  created(){
    let qualifiche=this.apiService.get('organizationchart/getqualifiche',{});
    let tree=this.apiService.get('organizationchart/gettree',{});
    forkJoin([ tree,qualifiche]).subscribe(data => {
      this.qualificheList=data[1].Result;
      data[0].Result.forEach((t)=>{
        this.orgList=JSON.parse(t.jsontree); 
        let indnodedir;
        this.orgList[0].childs.forEach((d,ind)=>{
          if(d.isManagement){
            indnodedir=ind;
          }
        });
        this.orgList[0].childs.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
        let cn:any={
          id:this.orgList[0].id,
          name:this.orgList[0].name,
          manager:this.orgList[0].manager,
          qualifica:this.orgList[0].qualifica,
          type:this.orgList[0].type,
        }
        this.treeHier.push(cn);
        this.buildTreeHier(this.orgList[0]);
        this.items = new DataManager(this.treeHier as JSON[]);
        this.diagram.dataSourceSettings = {
          id: 'id',
          parentId: 'parent',
          dataSource: this.items
        }
       
      });
    });
  }
  public bringToHome(){
    this.diagram.bringToCenter(
      this.diagram.nodes[0].wrapper.bounds
    );
  }
  rendered(){
    setTimeout(() => {
      this.bringToHome();
    }, 1000);
  }
  public layoutMenuItems=[
    { text: 'Orizzontale' },
    { text: 'Veritcale' },
  ];

  public zoomMenuItems = [
    { text: '400%' },
    { text: '300%' },
    { text: '200%' },
    { text: '150%' },
    { text: '100%' },
    { text: '75%' },
    { text: '50%' },
    { text: '25%' },
  ];
  public zoomContent() {
    return Math.round(this.diagram.scrollSettings.currentZoom * 100) + ' %';
  }
  public layoutContent(){
    if(this.diagram.layout.orientation=='LeftToRight'){
      return 'Verticale';
    } else {
      return 'Orizzontale';
    }
   
  }
  public layoutChange(args) {
    if(args.item.text=='Orizzontale'){
      this.layout = {
        //set the type as Organizational Chart
        type: 'OrganizationalChart',
        orientation:'TopToBottom'
      };
    } else {
      this.layout = {
        //set the type as Organizational Chart
        type: 'OrganizationalChart',
        orientation:'LeftToRight'
      };
     this.diagram.layout=this.layout;
     setTimeout(()=>{
      this.bringToHome();
     },2000);
     this.diagram.dataBind(); 
    }
    
  }
  // To perform zoom operation
  public zoomChange(args) {
    var currentZoom = this.diagram.scrollSettings.currentZoom;
    var zoom: ZoomOptions = {};
    switch (args.item.text) {
      case '400%':
        zoom.zoomFactor = 4 / currentZoom - 1;
        break;
      case '300%':
        zoom.zoomFactor = 3 / currentZoom - 1;
        break;
      case '200%':
        zoom.zoomFactor = 2 / currentZoom - 1;
        break;
      case '150%':
        zoom.zoomFactor = 1.5 / currentZoom - 1;
        break;
      case '100%':
        zoom.zoomFactor = 1 / currentZoom - 1;
        break;
      case '75%':
        zoom.zoomFactor = 0.75 / currentZoom - 1;
        break;
      case '50%':
        zoom.zoomFactor = 0.5 / currentZoom - 1;
        break;
      case '25%':
        zoom.zoomFactor = 0.25 / currentZoom - 1;
        break;
    }
    this.diagram.scrollSettings.currentZoom = args.item.text;
    var zoomCurrentValue = (document.getElementById('btnZoomIncrement') as any)
      .ej2_instances[0];
    zoomCurrentValue.content = this.diagram.scrollSettings.currentZoom;
    this.diagram.zoomTo(zoom);
  }

  public onItemClick(args: ClickEventArgs): void {
   
    switch (args.item.text) {
      case 'Zoom In':
        let zoomin: ZoomOptions = { type: 'ZoomIn', zoomFactor: 0.2 };
        this.diagram.zoomTo(zoomin);
        this.diagram.dataBind();
        break;
      case 'Zoom Out':
        let zoomout: ZoomOptions = { type: 'ZoomOut', zoomFactor: 0.2 };
        this.diagram.zoomTo(zoomout);
        this.diagram.dataBind();
        break;
    }
  }

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }
  changeModifica(){
    if(this.modifica){
      this.tool = DiagramTools.Default;
      this.diagram.tool=this.tool;
    } else {
       this.tool = DiagramTools.ZoomPan;
       this.diagram.tool=this.tool;
    }
    this.diagram.dataBind();
  }
  
  public search() {
   

    const searchText = this.searchNode
      .replace(/\s+/g, '')
      .toLowerCase();
    const searchWords = searchText.split(/\s+/);
    const searchRegex = new RegExp(
      searchWords.map((word) => `\\b${word}\\b`).join('.*'),
      'i'
    );
    this.matchingNodes = [];
    this.currentIndex = 0;
    
    this.diagram.clearSelection();
    if (searchText !== '') {
      this.matchingNodes = this.diagram.nodes.filter((node,ind) => {
        if (
          searchRegex.test(
            (node.data as any).name.replace(/\s+/g, '').toLowerCase()
          ) ||
          (node.data as any).name.toLowerCase().includes(searchText)
        ) {
          return true;
        }
      });
      if (this.matchingNodes && this.matchingNodes.length > 0) {
       
        this.diagram.select([this.matchingNodes[this.currentIndex]]);
        this.diagram.dataBind();
      }
    } else {
      this.matchingNodes = [];
    }
    this.diagram.bringToCenter(
      this.matchingNodes[this.currentIndex].wrapper.bounds
    );
  }

  public next() {
    if (this.matchingNodes && this.matchingNodes.length > 0) {
      this.matchingNodes[this.currentIndex].style.strokeColor = 'black';
      this.matchingNodes[this.currentIndex].style.strokeWidth = 1;
      this.currentIndex = (this.currentIndex + 1) % this.matchingNodes.length;
      this.matchingNodes[this.currentIndex].style.strokeColor = 'red';
      this.matchingNodes[this.currentIndex].style.strokeWidth = 3;
    }
    this.diagram.bringToCenter(
      this.matchingNodes[this.currentIndex].wrapper.bounds
    );
    this.diagram.dataBind();
  }

  public previous() {
    if (this.matchingNodes && this.matchingNodes.length > 0) {
      this.matchingNodes[this.currentIndex].style.strokeColor = 'black';
      this.matchingNodes[this.currentIndex].style.strokeWidth = 1;
      this.currentIndex =
        (this.currentIndex - 1 + this.matchingNodes.length) %
        this.matchingNodes.length;
      this.matchingNodes[this.currentIndex].style.strokeColor = 'red';
      this.matchingNodes[this.currentIndex].style.strokeWidth = 3;
    }
    this.diagram.bringToCenter(
      this.matchingNodes[this.currentIndex].wrapper.bounds
    );
    this.diagram.dataBind();
  }
}
